import React, { Component } from 'react';
import { Collapse,FormGroup } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';

export class SelectRuc extends Component {
  static displayName = SelectRuc.name;

  constructor (props) {
    super(props);

    this.state = {
      collapsed: true,
    };
  }

  componentDidMount(){
  }

  render () {
    const { isLoggedIn } = this.props;
    return (
      <div className="selectRuc">
        <div id="selectRUC" className="header-collapse" onClick={() => this.setState({collapsed: !this.state.collapsed})}>
          Selecciona RUC y Destino
          <SvgAssets icon={this.state.collapsed ? "icon-bottom" : "icon-top"} fill={c.azulClaro}/>
        </div>
        <Collapse isOpen={!this.state.collapsed}>
          <div className="body-collapse">
            <FormGroup>
              <SvgAssets icon="icon-maleta" fill={c.grisMedio}/>
              <select type="select" name="select" id="exampleSelect">
                <option>Inti Motors S.A.C - 81234567898</option>
              </select>
            </FormGroup>
            <FormGroup className="mb-0">
              <SvgAssets icon="icon-location" fill={c.grisMedio}/>
              <select type="select" name="select" id="exampleSelect">
                <option>Camilo Carrillo, Sa Miguel, Lima, Li...</option>
              </select>
            </FormGroup>
          </div>
        </Collapse>
      </div>
    );
  }
}
